import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { CompanyFile, CreateCompanyFileRequest, HttpResponse } from "@/types";

export function useCreateCompanyFile() {
  const currentCompanyId = useCurrentCompanyId();

  const mutation = useMutation({
    mutationFn: async ({
      createCompanyFileRequest,
    }: {
      createCompanyFileRequest: CreateCompanyFileRequest;
    }) => {
      const path = `companies/${currentCompanyId}/files`;
      const res = await guacHttpClient.postForm<
        CompanyFile,
        HttpResponse<CompanyFile>,
        CreateCompanyFileRequest
      >(path, createCompanyFileRequest);

      return res.data;
    },
  });

  return mutation;
}
